module.exports = __webpack_public_path__ + "static/img/40d47c0bfc4c438780913ea6a5c93711.a4d19c99.gif";